var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcRemark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "khsgbtl7ca",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1956",
    transform: "translate(-154 -1771)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 79",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(154 1771)",
    style: {
      fill: "url(#khsgbtl7ca)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M5618.3 306.633v8.332",
    transform: "translate(-5450.797 1476.029)",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2963",
    d: "M5618.3 306.633v.008",
    transform: "translate(-5450.797 1470.763)",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeWidth: 3
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRemark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-remark.7486121c7dd8b4cfc7ea12a4a477230c.svg";